import Vue from "vue";

Vue.config.productionTip = false;

import {
  Pagination,
  Dialog,
  Autocomplete,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Image,
  Input,
  // InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  // CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  // TimeSelect,
  // TimePicker,
  Popover,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  // Tag,
  Tree,
  // Alert,
  // Slider,
  // Icon,
  Row,
  Col,
  Upload,
  Progress,
  // Badge,
  // Card,
  Rate,
  // Steps,
  // Step,
  // Carousel,
  // CarouselItem,
  // Collapse,
  // CollapseItem,
  // Cascader,
  // ColorPicker,
  // Transfer,
  // Container,
  // Header,
  // Aside,
  // Main,
  // Footer,
  Loading,
  MessageBox,
  Message,
  // Notification
} from "element-ui";
import "@/common/styles/base/element-variables.scss";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
Vue.component(CollapseTransition.name, CollapseTransition);
import "element-ui/lib/theme-chalk/base.css"; //内置fade/zoom过渡动画
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(Image);
// Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
// Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
// Vue.use(TimeSelect);
// Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
// Vue.use(Tag);
Vue.use(Tree);
// Vue.use(Alert);
// Vue.use(Slider);
// Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Progress);
// Vue.use(Badge);
// Vue.use(Card);
Vue.use(Rate);
// Vue.use(Steps);
// Vue.use(Step);
// Vue.use(Carousel);
// Vue.use(CarouselItem);
// Vue.use(Collapse);
// Vue.use(CollapseItem);
// Vue.use(Cascader);
// Vue.use(ColorPicker);
// Vue.use(Transfer);
// Vue.use(Container);
// Vue.use(Header);
// Vue.use(Aside);
// Vue.use(Main);
// Vue.use(Footer);

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
// Vue.prototype.$notify = Notification  // Notification 未导入，手机浏览器上会报 ReferenceError
Vue.prototype.$message = Message;
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

import App from "./App.vue";
import store from "./store";

import "@/common/styles/global.scss";

import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { isLogin } from "./common/api";

import DataHeader from "@/components/dataheader/DataHeader.vue";
Vue.component("DataHeader", DataHeader);

import routers from "./router";
import Router from "vue-router";
Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  const result = originalPush.call(this, location);
  if (result && typeof result.catch === "function") {
    return result.catch((err) => err);
  }
  return result;
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  const result = originalReplace.call(this, location);
  if (result && typeof result.catch === "function") {
    return result.catch((err) => err);
  }
  return result;
};

const createRouter = () =>
  new Router({
    routes: routers.routes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

router.beforeEach((to, from, next) => {
  // 企微授权：URL 带 code 参数时，先跳到 loading 页换 token
  if (to.query.code && to.path !== "/auth-loading") {
    // 构建去掉 code 的目标路径，授权完成后跳回
    var cleanQuery = Object.assign({}, to.query);
    delete cleanQuery.code;
    var qs = Object.keys(cleanQuery)
      .map(function (k) {
        return k + "=" + cleanQuery[k];
      })
      .join("&");
    var redirectPath = to.path + (qs ? "?" + qs : "");
    next({
      path: "/auth-loading",
      query: { code: to.query.code, redirect: redirectPath },
    });
    return;
  }

  if (!to.matched.some((record) => record.meta.noAuth)) {
    NProgress.start();

    // console.log('from >>>> ', from)
    // console.log('to >>>> ', to)

    if (to.path == "/login") {
      next();
    } else {
      // 验证是否已登录
      isLogin({})
        .then((res) => {
          NProgress.done();

          let { code, data, msg } = res;

          if (code !== 0) {
            Message.error(msg);
            localStorage.clear();
            next({ path: "/login" });
          } else {
            // 权限id数组
            let ids = data || [];

            const routesList = routers.getRoutesList(ids);
            // console.log('routesList >>> ', routesList)

            // 判断接口返回的权限 和 本地存储的权限 是否一致
            if (localStorage.getItem("ids") == JSON.stringify(data)) {
              // 权限无变化
              if (to.path == "/") {
                next({ path: (routesList[0] && routesList[0].path) || "/" });
              } else {
                // 判断当前路径是否在routes里面
                if (routers.hasPermission(to.path)) {
                  next();
                } else {
                  Message.error("您没有权限访问这个页面，请联系管理员");

                  window.location.href = "/";
                }
              }
            } else {
              // 权限变化
              localStorage.setItem("ids", JSON.stringify(data));
              resetRouter();
              // 更新route
              routers.getRoutesList(ids).forEach((route) => {
                router.addRoute(route);
              });

              if (to.path == "/") {
                next({ path: (routesList[0] && routesList[0].path) || "/" });
              } else {
                // 判断当前路径是否在routes里面
                // 不能写成next(), 不然addRoutes不起作用
                // to.path 会造成刷新页面的时候 query 所带参数丢失
                if (routers.hasPermission(to.path)) {
                  next({ path: to.fullPath });
                } else {
                  Message.error("您没有权限访问这个页面，请联系管理员");

                  window.location.href = "/";
                }
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);

          NProgress.done();
          Message.error("服务器异常");
          next({
            path: "/login",
          });
        });
    }
  } else {
    next();
  }
});

router.afterEach(() => {
  Vue.nextTick(() => {
    const scrollContainer = document.querySelector(".app-container");
    if (scrollContainer) {
      scrollContainer.scrollTop = 0;
    }
  });
});

new Vue({
  router,
  store,
  render: (h) => h(App),
  /**
   * [created description] vue实例被销毁的时候（如：页面刷新），清除routes、ids的数据，使isLogin的时候能更新route
   * @return {[type]} [description]
   */
  created: function () {
    localStorage.removeItem("ids");
    localStorage.removeItem("routes");
  },
}).$mount("#app");
